import React from 'react';
import { connect } from 'react-redux';
import { ISO_ALPHA_2_COUNTRY_LIST, CONTINENT_LIST, REGIONAL_INSTANCE_LIST } from '../../constants';
import { enableRestriction } from '../../actions/reduxActions/currentTenant';
import RegionRestrictionEditor from '../RegionRestrictionEditor';
import RegionRestrictionListConnector from './RegionRestrictionListConnector';
import translations from '../../translations';
import { pathOr } from 'ramda';

export const Restrictions = ({
    restrictions,
    enableRestriction,
}) => {

    const restrictionsWithDefaults = {
        access: null,
        execution: null,
        ...restrictions,
    };

    return (
        <React.Fragment>
            <div className="restriction-widget">
                <strong>Access</strong>
                <p>
                    { translations['where flows in this tenant are accessible from'] }
                </p>
                <RegionRestrictionEditor
                    restriction={restrictionsWithDefaults.access}
                    restrictionName="access"
                    enableRestriction={enableRestriction}
                    countryList={ISO_ALPHA_2_COUNTRY_LIST}
                    continentList={CONTINENT_LIST}
                    RegionRestrictionList={RegionRestrictionListConnector}
                />
            </div>

            <div className="restriction-widget">
                <strong>Execution</strong>
                <p>
                    { translations['where flows in this tenant can be executed'] }
                </p>
                <RegionRestrictionEditor
                    restriction={restrictionsWithDefaults.execution}
                    restrictionName="execution"
                    enableRestriction={enableRestriction}
                    countryList={REGIONAL_INSTANCE_LIST}
                    RegionRestrictionList={RegionRestrictionListConnector}
                />
            </div>
        </React.Fragment>
    );
};

export const mapStateToProps = ({ currentTenant }) => ({
    restrictions: pathOr(null, ['restrictions', 'flowRestrictions'], currentTenant),
});

const mapDispatchToProps = {
    enableRestriction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Restrictions);
